module.exports = __webpack_public_path__ + "static/index/img/baikal-310.3ce4feb4.jpg";